// test1855
(1855 && 0);
